import React, { Component } from "react";
import { connect } from "react-redux";
import { AddOrganizationDialog } from "../dialogs/AddOrganizationDialog";
import { mapKV } from "../utils/map";
import { addOrganization } from "../redux/actions/organizationActions";

export class AddOrganization extends Component {
  state = {
    name: "",
    nameNotUnique: false,
    saveAvaliable: false,
    reportLinkID: ""
  };

  onNameChange = name => this.setState({ name }, this.checkSaveAvaliable);

  onReportLinkIDChange = reportLinkID => this.setState({ reportLinkID });

  checkSaveAvaliable = () => {
    const { name } = this.state;
    const { organizations } = this.props;
    let nameNotUnique = false;
    mapKV(organizations, (k, v) => {
      if (name.trim() === v.name) nameNotUnique = true;
    });

    this.setState({ nameNotUnique });

    let saveAvaliable = true;
    if (nameNotUnique || name === "") saveAvaliable = false;
    this.setState({ saveAvaliable });
  };

  onSave = () => {
    const { name, reportLinkID } = this.state;
    const { addOrganization, onClose } = this.props;
    addOrganization({ name, reportLinkID });
    onClose();
  };

  render() {
    const { onClose } = this.props;
    const { name, nameNotUnique, saveAvaliable, reportLinkID } = this.state;

    return (
      <AddOrganizationDialog
        onClose={onClose}
        name={name}
        onNameChange={this.onNameChange}
        nameNotUnique={nameNotUnique}
        saveAvaliable={saveAvaliable}
        onSave={this.onSave}
        reportLinkID={reportLinkID}
        onReportLinkIDChange={this.onReportLinkIDChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  organizations: state.data.organizations
});

const mapDispatchToProps = { addOrganization };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddOrganization);
